module.exports = __webpack_public_path__ + "static/media/warning-logo.63267490.svg";